import { EVENT_TRIGGERS } from './TrackEventTriggers';
import type { RetakerMode } from './ManualRetakerTypes';

export const MANUAL_RETAKER_MODES: {
  [Key in RetakerMode]: Key;
} = {
  basicScreenshot: 'basicScreenshot',
  dynamicElements: 'dynamicElements',
  cookiesBanners: 'cookiesBanners',
};

export const MANUAL_RETAKER_MODE_EVENT_MAP = {
  [MANUAL_RETAKER_MODES.basicScreenshot]: EVENT_TRIGGERS.MANUAL_RETAKE,
  [MANUAL_RETAKER_MODES.dynamicElements]: EVENT_TRIGGERS.MANUAL_RETAKE_DYNAMIC,
  [MANUAL_RETAKER_MODES.cookiesBanners]: EVENT_TRIGGERS.MANUAL_RETAKE_COOKIES_BANNERS,
};
